import { Result } from '../../../../../common/models/Result';
import { HttpServiceBase } from '../../../../../common/services/HttpServiceBase';
import { MemberAccount } from '../../../../models/MemberAccount';

export class GetMemberAccountByShopifyCustomerIdService extends HttpServiceBase {

  handle = (shopifyCustomerId: number, bearerToken: string): Promise<Result<GetMemberAccountByShopifyCustomerIdOutput> | null> => {
    const promise = this.http.get<Result<GetMemberAccountByShopifyCustomerIdOutput>>(
      `${this.baseUrlZerezesApi}/club-pdv/member-account/${shopifyCustomerId}`,
      bearerToken
    );
    return promise;
  }
}

export class GetMemberAccountByShopifyCustomerIdOutput {
  memberAccount?: MemberAccount;
  memberAccountIsEligibleToGetCashRewardValue?: boolean;
}